import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CurrencyDto } from 'src/app/domain/models/dto/currency.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private readonly http: HttpClient) { }

  get(currency: string) {
    return this.http.get<ResponseObjectModel<CurrencyDto>>(`${environment.API_BASE_URL}/v1/currency/bank-channels/${currency}`);
  }


}
